module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAqAQMAAABbZ+PLAAAAA1BMVEUyxf8bGsCiAAAAC0lEQVQI12MYUAAAAH4AAasqQLMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/rectangular.png
// module id = TEj/
// module chunks = 1